// Solid colours for the available museum label.
export const MUSEUM_LABEL_THEME_VARS = {
  white: {
    '--museum-label-bg': '#ffffff',
    '--museum-label-text': '#0f172a',
    '--museum-label-muted': '#475569',
  },
};
